<template>
    <!-- Modal -->
    <div class="modal fade" id="guestBookedModal" tabindex="-1" role="dialog" aria-labelledby="guestBookedModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title font-weight-bold" id="guestBookedModalLabel">{{titleCase(initGuest.guestName)}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-on:click="set_this_null">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <div class="row">
                       <div class="col-md-3 text-left">
                           <div class="form-group">
                               <label for="bookedFrom" class="font-weight-bold">Booked Check-In:</label>
                               <input type="date"
                                      class="form-control form-control-sm"
                                      id="bookedFrom"
                                      aria-describedby="bookedFrom"
                                      v-on:input="setBookedIn"
                                      v-model="booked_in"
                                      placeholder="Date From">
                           </div>
                       </div>

                        <div class="col-md-3 text-left">
                            <div class="form-group">
                                <label for="bookedFrom" class="font-weight-bold">Booked Check-Out:</label>
                                <input type="date"
                                       class="form-control form-control-sm"
                                       id="bookedTo"
                                       aria-describedby="bookedTo"
                                       v-on:input="setBookedOut"
                                       v-model="booked_out"
                                       placeholder="Date To">
                            </div>
                        </div>
                    </div>

                    <hr class="border-secondary">

                    <div class="row">
                        <div class="col-md-6 text-left">
                          <div class="form-group">
                            <label for="exampleFormControlSelect1" class="font-weight-bold">Select Floor :</label>
                            <select class="form-control form-control-sm w-25 font-weight-bold" id="exampleFormControlSelect1" v-model="floor_id" v-on:change="getRooms">
                              <option  :value="null" :selected="floor_id == null">---</option>
                              <option v-for="floor in floors"
                                      :value="floor.id"
                                      :key="floor.id"
                                      :selected="floor.id == floor_id"
                                      class="font-weight-bold">{{floor.code}}</option>
                            </select>
                          </div>
                        </div>
                    </div>

                    <div class="row mt-2">
                        <div class="col-md-5">
                            <div class="text-left">
                                <span class="font-weight-bold">Available Room</span>
                            </div>
                            <div class="table-responsive mt-2">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th scope="col" width="80">
                                                <button class="btn btn-sm" v-on:click="setSelectAvailable" v-bind:class="{'tnkc-success' : isInAvailable,'tnkc-secondary' : !isInAvailable}">
                                                    {{isInAvailable ? 'Select' : 'Undo'}}
                                                </button>
                                            </th>
                                            <th scope="col"  width="129">Rooms</th>
                                            <th scope="col" width="100">Beds</th>
                                        </tr>
                                    </thead>

                                    <tbody style="height: 180px;">
                                    <tr class="text-left" v-for="(bedAvailable,index) in guestBedAvailable" :key="index">
                                        <td width="80" scope="row">
                                            <div class="form-check">
                                                <input type="radio" name="bedAvailableButton"
                                                       :id="'bedAvailable'+bedAvailable.id"
                                                       :disabled="isInAvailable"
                                                       v-on:click="setBedRoomInAvailable(bedAvailable)"
                                                       :value="bedAvailable">
                                            </div>
                                        </td>
                                        <td width="129">{{bedAvailable.name}}</td>
                                        <td width="100">{{bedAvailable.code}}</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div class="col-md-7">
                            <div class="text-left">
                                <span class="font-weight-bold">Occupied Room</span>
                            </div>
                            <div class="table-responsive mt-2">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th scope="col" width="80">
                                            <button class="btn btn-sm " v-on:click="setSelectOccupied" v-bind:class="{'tnkc-success' : isInOccupied,'tnkc-secondary' : !isInOccupied}">
                                                {{isInOccupied ? 'Select' : 'Undo'}}
                                            </button>
                                        </th>
                                        <th scope="col">Rooms</th>
                                        <th scope="col" width="100">Beds</th>
                                        <th scope="col" >Available Date</th>
                                    </tr>
                                    </thead>

                                    <tbody style="height: 180px;">
                                        <tr class="text-left" v-for="(bedOccupied,index) in guestBedOccupied" :key="index" v-bind:class="{'tnkc-success':!bedOccupied.available_date}">
                                            <td width="80" scope="row">
                                                <div class="form-check">
                                                    <input type="radio" name="bedOccupiedButton"
                                                           :disabled="isInOccupied"
                                                           :id="'bedOccupied'+bedOccupied.id"
                                                           v-on:click="setBedRoomInOccupied(bedOccupied)"
                                                           :value="bedOccupied">
                                                </div>
                                            </td>
                                            <td scope="row">{{bedOccupied.name}}</td>
                                            <td scope="row" width="100">{{bedOccupied.code}}</td>
                                            <td scope="row" class="font-weight-bold small" v-show="bedOccupied.available_date">{{bedOccupied.available_date | moment("DD MMM YYYY - HH:mm")}}</td>
                                           <td class="font-weight-bold small" v-show="!bedOccupied.available_date">Check-Out/Available</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-sm tnkc-primary" v-on:click="save_guest_booking">Save changes</button>
                    <button type="button" class="btn btn-sm tnkc-secondary" data-dismiss="modal" v-on:click="set_this_null">Close</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
  import {appMixins} from '../../../mixins/app.mixins';
  import {mapGetters,mapActions} from 'vuex';

  export default {
    props:{
      initGuest : Object,
      setNull : {type:Function},

    },
    mixins:[appMixins],
    name: 'guestBookingModal',
    data(){
      return {
        hotel_id : 1,
        floor_id : null,

        booked_in: '',
        booked_out: '',

        isInAvailable: true,
        isInOccupied: true,

        roomAvail: '',
        roomOccupied: '',

        isRoom : true,

      }
    },
    methods : {
      ...mapActions(
          [
            'bedsPerRoomGuest',
            'setNullGuestBeds',
            'createNewGuestBooked',
            'getGuestList',
            'getFloorsByHotel'
          ],
      ),

      set_this_null(){
        this.booked_in = null;
        this.booked_out = null;
        this.setNullGuestBeds();

        //reset button on default
        this.isInAvailable = true;
        this.isInOccupied = true;
      },

      async save_guest_booking() {
        this.newGuestBooking.guest_id = this.initGuest.guestId;
        if (await this.questionAlert('Are you sure you want to booked this guest.')) {
          this.createNewGuestBooked(this.newGuestBooking).then((res)=>{
            if(res == true){
              this.successAlert('Guest Booked Successfully');
              this.getGuestList(this.guestParams);
              this.booked_in = null;
              this.booked_out = null;
              $('#guestBookedModal').modal('hide');
            }
          });
        }
      },

      setBookedIn(){
          this.newGuestBooking.booked_check_in = this.booked_in;
          this.getRooms();
      },

      setBookedOut(){
          this.newGuestBooking.booked_check_out = this.booked_out;
          this.getRooms();
      },


      getRooms(){
        this.isRoom = this.floor_id ? false : true;
        let startDate = Date.parse(this.booked_in);
        let endDate = Date.parse(this.booked_out);
        if (startDate > endDate) {
          this.warningAlert('The check-out date must come after the check-in date');
        }
        this.availableRooms();
      },

      availableRooms(){
        const params = {
          dateFrom : this.booked_in ? this.booked_in : null,
          dateTo : this.booked_out ? this.booked_out : null,
          hotel_id : this.hotel_id, // default 1
          floor_id: this.floor_id,
        }
        this.bedsPerRoomGuest(params);
      },

      setBedRoomInAvailable(objData){
        this.booked_in =  objData.available_date ?  this.formatDate(objData.available_date) : this.formatDate();
        this.newGuestBooking.hotel_id = objData.hotel_id;
        this.newGuestBooking.floor_id = objData.floor_id;
        this.newGuestBooking.room_id = objData.id;
        this.newGuestBooking.bed_id = objData.bed_id;
        this.newGuestBooking.booked_check_in = this.booked_in;
      },

      setBedRoomInOccupied(objData){
        this.booked_in =   this.formatDate(objData.available_date);
        this.newGuestBooking.hotel_id = objData.hotel_id;
        this.newGuestBooking.floor_id = objData.floor_id;
        this.newGuestBooking.room_id = objData.id;
        this.newGuestBooking.bed_id = objData.bed_id;
        this.newGuestBooking.booked_check_in = this.booked_in;
      },

      setSelectAvailable() {
        this.isInAvailable = !this.isInAvailable;
        this.isInOccupied = true;
        this.clearAvailableRadioBr();
        this.clearOccupiedRadioBr();
      },

      setSelectOccupied() {
         if(!this.isInOccupied){
           this.booked_in = null;
         }
        this.isInAvailable = true;
        this.isInOccupied = !this.isInOccupied;
        this.clearAvailableRadioBr();
        this.clearOccupiedRadioBr();
      },

      clearAvailableRadioBr() {
        let ele = document.getElementsByName('bedAvailableButton');
        for (let i = 0; i < ele.length; i++) {
          ele[i].checked = false;
        }
        // this.newBooking.room_id = '';
      },

      clearOccupiedRadioBr() {
        let ele = document.getElementsByName('bedOccupiedButton');
        for (let i = 0; i < ele.length; i++) {
          ele[i].checked = false;
        }
        // this.newBooking.room_id = '';
      },

      getFloors(){
        this.getFloorsByHotel({hotel_id: this.hotel_id});
      }
    },


    computed : {
      ...mapGetters(['guestBedAvailable','guestBedOccupied','newGuestBooking','guestParams','floors']),
    },

    created() {
      this.getFloors();
    },


    mounted() {

    },

    destroyed() {

    }
  };
</script>

<style scoped>
    input[type=radio] {
        transform: scale(1.6);
    }

    table {
        display: flex;
        flex-flow: column;
        width: 100%;

    }

    thead {
        flex: 0 0 auto;
    }

    tbody {
        flex: 1 1 auto;
        display: block;
        overflow-y: auto;
        overflow-x: hidden;
    }

    tr {
        width: 100%;
        display: table;
        table-layout: fixed;
    }


    ::-webkit-scrollbar {
      width: 15px !important;
    }
</style>
